export default __webpack_public_path__ + "static/media/phone-2-inverted.88c430f4.png";